import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessorBase } from '../value-accessor-base';

@Component({
  selector: 'app-tin-control',
  templateUrl: './tin-control.component.html',
  styleUrls: ['./tin-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TinControlComponent,
      multi: true,
    },
  ],
})
export class TinControlComponent extends ValueAccessorBase<string>
  implements OnInit {
  xvalue: any = "";
  @Input() public label: string = '';
  @Input() public helptext: string = '';
  @Input() public name: string = '';
  @Input() public placeholder: string = '';
  @Input() public icononly = 'false';
  @Input() public search = 'false';
  @Input() public clearbtn = false;
  @Input() public mandatory = false;
  @Input() public upperCase = false;
  @Input() public maxlength = 1000;
  // tslint:disable-next-line: no-output-rename
  @Output('onblur') onblur: EventEmitter<any> = new EventEmitter();
  @Output('onenter') onenter: EventEmitter<any> = new EventEmitter();
  @Output('onClear') onClear: EventEmitter<any> = new EventEmitter();
  @ViewChild('inputbox', { static: false }) inputbox!: ElementRef;
  @ViewChild('selectInput') selectInput!: ElementRef;
  @Output() onsearchevent: EventEmitter<any> = new EventEmitter<any>();
  // tslint:disable-next-line: variable-name
  errorTrueNow = false;
  @Input()
  set errorTrue(errorTrue: boolean) {
    this.errorTrueNow = errorTrue || false;
  }
  get errorTrue() {
    return this.errorTrueNow;
  }
  constructor() {
    super();
  }

  btnClickedNow = false;
  @Input()
  set btnClicked(btnClicked: boolean) {
    this.btnClickedNow = btnClicked || false;
  }
  get btnClicked() {
    return this.btnClickedNow;
  }

  errorTextNow = '';
  @Input()
  set errorText(errorText: string) {
    this.errorTextNow = errorText || '';
  }
  get errorText() {
    return this.errorTextNow;
  }

  ngOnInit() {
    this.getValue().subscribe(async (xvalue) => {
      if (xvalue) {
        if (this.value) {

          this.xvalue = await this.checkTIN(this.value.toString());
        } else {
          this.xvalue = "";
        }
      }
    });
  }

  // tslint:disable-next-line: typedef
  blured() {
    this.onblur.next();
  }

  // tslint:disable-next-line: typedef
  setFocus() {
    this.inputbox.nativeElement.focus();
    this.inputbox.nativeElement.select();
  }

  checkenter(event: any) {
    if (event.key === 'Enter') {
      this.onenter.next();
    }
  }

  onFocus() {
    this.selectInput.nativeElement.focus();
  }

  onSearch() {
    this.onsearchevent.emit();
  }
  doClear() {
    this.xvalue = '';
    this.value = '';
    this.errorTextNow = '';
    this.onClear.next();
  }


  @HostListener("input", ["$event"]) async onInputChange($event: any) {
    // // console.log($event);
    

    if ($event.inputType !== "deleteContentBackward") {
      let val = await this.checkTIN($event.target.value.toString());
      $event.target.value = val;
      this.xvalue = val;
      this.errorTextNow = 'Tax ID No is Invalid';
    }
    else {
      this.errorTextNow = '';
    }
    let tempValue = this.xvalue.split('-').join("");
    // // console.log(tempValue);
    if (tempValue.length === 9) {
      this.errorTextNow = '';
      this.value = this.xvalue.split('-').join("");
      // this.change.emit(this.value);
    } else {
      this.value = this.xvalue.split('-').join("");   // for errorText
      this.errorTextNow = 'Tax ID No is Invalid';
      // this.value = "";
      // this.change.emit(this.value);
    }
    if (tempValue.length === 0) {
      this.errorTextNow = '';
    }
  };
  // xx-xxxxx-x-x
  checkTIN(tin: any) {
    return new Promise((resolve) => {
      let val = tin.toString();
      val = val.replace(/\D/g, '');
      val = val.replace(/^(\d{2})/, '$1-');
      val = val.replace(/^(\d{2})-(\d{5})/, '$1-$2-');
      val = val.replace(/^(\d{2})-(\d{5})-(\d{1})/, '$1-$2-$3-');
      val = val.replace(/^(\d{2})-(\d{5})-(\d{1})-(\d{1}).*/, '$1-$2-$3-$4');

      // val = val.replace(/-(\d{5})/, '-$1-');
      // val = val.replace(/-(\d{1})/, '-$1-');
      // val = val.replace(/(\d)-(\d{4}).*/, '$1-$2');
      resolve(val);
    })
  }


}
